<template>
  <div class="LKMunMehFormsList">
    <ComponentFilter
      ref="filters"
      @change="onChangeDebounced"
    />

    <BTableCommon
      type="munmeh-curator-forms"
      :list="list"
      :pagination="pagination"
      :loading="isLoading"
      :mun-meh-id="munMeh.id"
      :reg-meh="munMeh.is_reg_meh"
      fixed-header

      @action:view="onViewForm"
      @action:accept="onSaveExperts"
      @change:sort="onChangeSort"
      @change:pagination="onChangePagination"
      @change:experts="onChangeExperts"
    />
  </div>
</template>

<script>
import BTableCommon from '@/components/tables/BTableCommon.vue'
import ComponentFilter from '@/views/LKMunMeh/components/FormsListModal/LKMunMehFormsListFilter.vue'
import { DEFAULT_PER_PAGE } from '@/helpers/enums/params'
import { cloneDeep } from 'lodash'
import { LkMunMehAdapter } from '@/views/LKMunMeh/store/LkMunMehAdapter'
import { LK_MUN_MEH_FORM_HOST_VIEW_ROUTES } from '@/views/LKMunMeh/HostView/utils'

const DEFAULT_PARAMS = {
  page: 1,
  per_page: DEFAULT_PER_PAGE,
  count: 0,
}

export default {
  name: 'LKMunMehFormsList',
  components: { BTableCommon, ComponentFilter },
  props: {
    munMeh: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    isLoading: false,
    list: [],
    pagination: { ...DEFAULT_PARAMS },
    ordering: void 0,
  }),
  methods: {
    asyncData() {
      const params = { ...this.pagination }
      this.onGetData(params)
    },
    async onViewForm(form) {
      const { topic_slug, slug } = this.$route.params

      this.$emit('close')

      await this.$router.push({
        name: LK_MUN_MEH_FORM_HOST_VIEW_ROUTES.FORM,
        params: {
          munMehId: this.munMeh.id,
          formId: form.id,
          slug,
          topic_slug,
        },
      })
    },
    async onSaveExperts(form, callback) {
      const unwatch = callback?.()
      const adapter = new LkMunMehAdapter()

      const data = {
        first_level_expert_one_id: form.first_level_expert_one_id,
        first_level_expert_two_id: form.first_level_expert_two_id,
        second_level_expert_id: form.second_level_expert_id,
      }

      try {
        await adapter.api.updateExperts(form.id, data)
        this.list = this.list.map((el) => {
          if (el.changed) {
            // eslint-disable-next-line no-param-reassign
            el.changed = false
          }
          return el
        })
      } catch (e) {
        this.$notice.errors(e)
      }
      unwatch?.()
    },
    onChangePagination(options) {
      const { filters, ate_filter } = this.prepareFilterData(this.$refs.filters.form)
      const params = {
        ...this.pagination,
        ...filters,
        ate_filter,
        ...options,
        ordering: this.ordering,
      }

      this.pagination.page = options.page || DEFAULT_PARAMS.page
      this.pagination.per_page = options.per_page || DEFAULT_PARAMS.per_page

      return this.onGetData(params)
    },
    onChangeSort(ordering) {
      const { filters, ate_filter } = this.prepareFilterData(this.$refs.filters.form)
      this.pagination.page = 1
      const params = {
        ...filters,
        ate_filter,
        ordering,
        ...this.pagination,
      }
      this.ordering = ordering

      return this.onGetData(params)
    },
    async onGetData(params) {
      this.isLoading = true
      const adapter = new LkMunMehAdapter()

      try {
        const result = await adapter.api.getCuratorForms(this.munMeh.id, params)
        this.list = result.data
        this.pagination.count = result.meta.count
      } catch (e) {
        this.$notice.errors(e)
      }
      this.isLoading = false
    },
    async onChangeDebounced(options) {
      const { filters, ate_filter } = this.prepareFilterData(options)
      const params = {
        ...filters,
        ate_filter,
        ...this.pagination,
        page: 1,
      }

      await this.onGetData(params)
    },
    /**
     * Callback изменения эксперта в строке таблицы.
     * @param id Идентификатор объекта (строки)
     * @param errors Массив ошибок для ДАННОЙ строки, а не всей таблицы
     */
    onChangeExperts(id, errors) {
      const err = errors.all()
      this.list = this.list.map((el) => {
        if (el.id === id) {
          return {
            ...el,
            changed: err.length <= 0,
          }
        }
        return el
      })

      if (err.length > 0) {
        this.$notice.errors(err.join('<br />'))
      }
    },
    prepareFilterData(options) {
      const filters = cloneDeep(options)
      const ate_filter = filters.region?.id || filters.municipality?.id || filters.school?.id
      delete filters.region
      delete filters.municipality
      delete filters.school
      return { filters, ate_filter }
    },
  },
}
</script>
